module.exports = __webpack_public_path__ + "media/images/icons/flags/NL-a95a80818ed70138833ab32ab7e6aa0a.svg";